var map = {
	"./complete.json": 68204,
	"./confetti-jump-2.json": 94429,
	"./confetti-jump.json": 8282,
	"./notification.json": 83136,
	"./reward.json": 1624,
	"./switch-off.json": 38091,
	"./yellow-arrow.json": 47999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48812;